// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* CHATBOX
=============== */
/* .chatbox {
  position: absolute;
  bottom: 30px;
  right: 30px;
} */
.chatbox {
  position: fixed;
  bottom: 90px;
  right: 105px;
  /* z-index: 999; Ensure it's above other content */
}

/* CONTENT IS CLOSE */
.chatbox__support {
  display: flex;
  flex-direction: column;
  background: #eee;
  width: 300px;
  height: 350px;
  transition: all .5s ease-in-out;
}

/* CONTENT ISOPEN */
.chatbox--active {
  transform: translateY(-40px);
  z-index: 999;

}

/* BUTTON */
.chatbox__button {
  text-align: right;
}

.send__button {
  padding: 6px;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}


/* HEADER */
.chatbox__header {
  position: sticky;
  top: 0;
  background: orange;
}

/* MESSAGES */
.chatbox__messages {
  margin-top: auto;
  display: flex;
  overflow-y: scroll;
  flex-direction: column-reverse;
}

.messages__item {
  background: orange;
  max-width: 60.6%;
  width: -moz-fit-content;
  width: fit-content;
}

.messages__item--operator {
  margin-left: auto;
}

.messages__item--visitor {
  margin-right: auto;
}

/* FOOTER */
.chatbox__footer {
  position: sticky;
  bottom: 0;
}

.chatbox__support {
  background: #f9f9f9;
  height: 450px;
  width: 350px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

/* HEADER */
.chatbox__header {
  background:#800925;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: white;
  border-top-left-radius: 37%;
}

.chatbox__image--header {
  right: 50px;
  min-width: 50px;
  position: absolute;
  margin: -30px 0 0 -30px;
  padding: 13px;
}

.chatbox__heading--header {
  font-size: 1.2rem;
  color: white;
}

.chatbox__description--header {
  font-size: .9rem;
  color: white;
}

/* Messages */
.chatbox__messages {
  padding: 0 20px;
}

.messages__item {
  margin-top: 10px;
  background: #E0E0E0;
  padding: 8px 12px;
  max-width: 70%;
}

.messages__item--visitor,
.messages__item--typing {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.messages__item--operator {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background: red;
  color: white;
}

/* FOOTER */
.chatbox__footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px;
  background: #800925;
  box-shadow: white;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  margin-top: 20px;
}

.chatbox__footer input {
  width: 80%;
  border: none;
  padding: 10px 10px;
  border-radius: 30px;
  text-align: left;
}

.chatbox__send--footer {
  color: white;
}

.chatbox__button button,
.chatbox__button button:focus,
.chatbox__button button:visited {
  padding: 10px;
  /* background: white; */
  border: none;
  outline: none;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 50px;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.chat-bot {
  position: fixed;
  bottom: 40px;
  right: 50px;
  z-index: 99;
  font-size: 15px;
  border: none;
  outline: none;
  color: white;
  cursor: pointer;
  padding: 2px;
}
button.chat-btn {
  min-width: 50px;
  position: absolute;
  margin: -30px 0 0 -30px;
  /* background: linear-gradient(170deg, #008abf, #4ac5ff); / */
  background-color: #890025bf;
  border-radius: 50%;
  padding: 13px;
}

img.chat-bot-img {
  width: 100%;
  overflow: hidden;
}
/* Adjust message alignment based on sender */

.message-user-right {
  justify-content: flex-end;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.message-user-right strong ,.message-user-left strong {
  font-size: 12px;
}


.message-user-left {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
  flex-direction: column;
}

/* Styling for user messages */
.message-user-right .message-user-right-img,
.message-user-left .message-user-left-img {
  /* Styles for message sender's image/avatar */
  /* Adjust styles as needed */
  display: flex;
  align-items: flex-end;
}

.message-user-right .message-user-right-text,
.message-user-left .message-user-left-text {
  /* Styles for message text */
  background-color: #E0E0E0;
  padding: 8px 12px;
  border-radius: 20px;
  max-width: 70%;
  word-wrap: break-word;
}

/* Styling for AI messages */
.message-user-left .message-user-left-text {
  background-color: #800925;
  color: white;
  /* Additional AI message styles */
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/AIChat.css"],"names":[],"mappings":";AACA;iBACiB;AACjB;;;;GAIG;AACH;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kDAAkD;AACpD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B,YAAY;;AAEd;;AAEA,WAAW;AACX;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;;AAGA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,6DAA6D;EAC7D,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA,6CAA6C;;AAE7C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;;EAEE,6CAA6C;EAC7C,4BAA4B;EAC5B,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,iCAAiC;AACnC","sourcesContent":["\n/* CHATBOX\n=============== */\n/* .chatbox {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n} */\n.chatbox {\n  position: fixed;\n  bottom: 90px;\n  right: 105px;\n  /* z-index: 999; Ensure it's above other content */\n}\n\n/* CONTENT IS CLOSE */\n.chatbox__support {\n  display: flex;\n  flex-direction: column;\n  background: #eee;\n  width: 300px;\n  height: 350px;\n  transition: all .5s ease-in-out;\n}\n\n/* CONTENT ISOPEN */\n.chatbox--active {\n  transform: translateY(-40px);\n  z-index: 999;\n\n}\n\n/* BUTTON */\n.chatbox__button {\n  text-align: right;\n}\n\n.send__button {\n  padding: 6px;\n  background: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n\n/* HEADER */\n.chatbox__header {\n  position: sticky;\n  top: 0;\n  background: orange;\n}\n\n/* MESSAGES */\n.chatbox__messages {\n  margin-top: auto;\n  display: flex;\n  overflow-y: scroll;\n  flex-direction: column-reverse;\n}\n\n.messages__item {\n  background: orange;\n  max-width: 60.6%;\n  width: fit-content;\n}\n\n.messages__item--operator {\n  margin-left: auto;\n}\n\n.messages__item--visitor {\n  margin-right: auto;\n}\n\n/* FOOTER */\n.chatbox__footer {\n  position: sticky;\n  bottom: 0;\n}\n\n.chatbox__support {\n  background: #f9f9f9;\n  height: 450px;\n  width: 350px;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n/* HEADER */\n.chatbox__header {\n  background:#800925;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 20px;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  box-shadow: white;\n  border-top-left-radius: 37%;\n}\n\n.chatbox__image--header {\n  right: 50px;\n  min-width: 50px;\n  position: absolute;\n  margin: -30px 0 0 -30px;\n  padding: 13px;\n}\n\n.chatbox__heading--header {\n  font-size: 1.2rem;\n  color: white;\n}\n\n.chatbox__description--header {\n  font-size: .9rem;\n  color: white;\n}\n\n/* Messages */\n.chatbox__messages {\n  padding: 0 20px;\n}\n\n.messages__item {\n  margin-top: 10px;\n  background: #E0E0E0;\n  padding: 8px 12px;\n  max-width: 70%;\n}\n\n.messages__item--visitor,\n.messages__item--typing {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n\n.messages__item--operator {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n  background: red;\n  color: white;\n}\n\n/* FOOTER */\n.chatbox__footer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px;\n  background: #800925;\n  box-shadow: white;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n  margin-top: 20px;\n}\n\n.chatbox__footer input {\n  width: 80%;\n  border: none;\n  padding: 10px 10px;\n  border-radius: 30px;\n  text-align: left;\n}\n\n.chatbox__send--footer {\n  color: white;\n}\n\n.chatbox__button button,\n.chatbox__button button:focus,\n.chatbox__button button:visited {\n  padding: 10px;\n  /* background: white; */\n  border: none;\n  outline: none;\n  border-top-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-left-radius: 50px;\n  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n.chat-bot {\n  position: fixed;\n  bottom: 40px;\n  right: 50px;\n  z-index: 99;\n  font-size: 15px;\n  border: none;\n  outline: none;\n  color: white;\n  cursor: pointer;\n  padding: 2px;\n}\nbutton.chat-btn {\n  min-width: 50px;\n  position: absolute;\n  margin: -30px 0 0 -30px;\n  /* background: linear-gradient(170deg, #008abf, #4ac5ff); / */\n  background-color: #890025bf;\n  border-radius: 50%;\n  padding: 13px;\n}\n\nimg.chat-bot-img {\n  width: 100%;\n  overflow: hidden;\n}\n/* Adjust message alignment based on sender */\n\n.message-user-right {\n  justify-content: flex-end;\n  margin-bottom: 10px;\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n}\n.message-user-right strong ,.message-user-left strong {\n  font-size: 12px;\n}\n\n\n.message-user-left {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n  flex-direction: column;\n}\n\n/* Styling for user messages */\n.message-user-right .message-user-right-img,\n.message-user-left .message-user-left-img {\n  /* Styles for message sender's image/avatar */\n  /* Adjust styles as needed */\n  display: flex;\n  align-items: flex-end;\n}\n\n.message-user-right .message-user-right-text,\n.message-user-left .message-user-left-text {\n  /* Styles for message text */\n  background-color: #E0E0E0;\n  padding: 8px 12px;\n  border-radius: 20px;\n  max-width: 70%;\n  word-wrap: break-word;\n}\n\n/* Styling for AI messages */\n.message-user-left .message-user-left-text {\n  background-color: #800925;\n  color: white;\n  /* Additional AI message styles */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
